'use client';

import type { ReactNode } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import { TimelineDetails } from './TimelineDetails';
import { TimelineIcon } from './TimelineIcon';

import styles from './TimelineSlot.module.scss';

type ContainerProps = BaseComponentProps & {
  title: string;
  description?: string;
  payload?: ReactNode;
  payloadDefaultOpen?: boolean;
  date: string;
  last?: boolean;
  icon: ReactNode;
  direction?: 'vertical' | 'horizontal';
  onOpenSlot?: () => void;
  onCloseSlot?: () => void;
};

function TimelineSlot({
  style,
  className,
  title,
  description,
  payload,
  payloadDefaultOpen,
  date,
  last,
  icon,
  direction,
  testId = 'ui-timeline-slot',
  onOpenSlot,
  onCloseSlot,
}: ContainerProps) {
  return (
    <div
      style={style}
      className={classnames(
        styles['main'],
        direction && styles[`main--${direction}`],
        className,
      )}
      data-testid={testId}
    >
      <TimelineIcon
        icon={icon}
        last={last}
        direction={direction}
        testId={`${testId}_icon`}
      />
      <TimelineDetails
        title={title}
        description={description}
        payload={payload}
        payloadDefaultOpen={payloadDefaultOpen}
        date={date}
        testId={`${testId}_content`}
        onOpenSlot={onOpenSlot}
        onCloseSlot={onCloseSlot}
      />
    </div>
  );
}

export { TimelineSlot };
